import { useIntl } from 'react-intl';
import React from 'react';

import type { ModalRefType } from '../../Modal';

import { ModalFooter, ModalHeader, Modal } from '../../Modal';
import { useResponsive } from '../../../hooks';
import { TextField } from '../../Fields';
import Button from '../../Button';
import messages from './messages';

export interface AddNewModalProps {
  onAddNew: (value: string) => void;
  onCancel: () => void;
  helpText?: string;
  label?: string;
  open: boolean;
}
export const AddNewModal = ({
  helpText,
  label,
  onAddNew,
  onCancel,
  open,
}: AddNewModalProps) => {
  const { formatMessage } = useIntl();
  const ref = React.useRef<ModalRefType>(null);
  const isMobile = useResponsive('down', 'sm');
  const [value, setValue] = React.useState('');
  React.useEffect(() => {
    if (open) {
      ref.current?.open();
    } else {
      ref.current?.close();
    }
  }, [open]);
  return (
    /* The add-new modal is always opened from an autocomplete that already
       lives inside something else — a MUI Dialog or an open DropdownMenu — so
       the overlay must out-rank both, unlike the default z-20. */
    <Modal elevated onClose={onCancel} title={label} ref={ref}>
      <ModalHeader>
        <div />
      </ModalHeader>
      <TextField
        onChange={(e) => setValue(e.target.value)}
        helperText={helpText}
        className="mt-2"
        name="addNew"
        label={label}
        fullWidth
      />
      <ModalFooter>
        <Button fullWidth={isMobile} variant="outlined" onClick={onCancel}>
          {formatMessage(messages.cancel)}
        </Button>
        <Button
          onClick={() => onAddNew(value)}
          startIcon={{ type: 'add' }}
          fullWidth={isMobile}
          variant="contained"
          className="ml-4"
        >
          {formatMessage(messages.add)}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
